<template>
  <div class="breadcrumb_wrapper">
    <ul class="breadcrumb">
      <li v-for="(page, i) of pages" :key="i" :class="i === pages.length - 1 ? 'current' : ''">
        <a :href="page.url">{{page.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  components: {
  },
  directives: {
  },
  props: {
    crumbPages: Array
  },
  data() {
    return {
    };
  },
  computed: {
    pages: function() {
      return this.crumbPages;
    }
  },
  methods: {
  },
  mounted: function() {
  }
}
</script>
<style lang="scss" scoped>
.breadcrumb_wrapper {
  width: 100%;
  padding: 14px 0;
  background: #F5F8FA;

  ul.breadcrumb {
    width: 940px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;

    @media #{$small} {
      width: 100%;
      padding: 0 psd(16);
    }

    li {
      padding-right: 19px;
      margin-right: 3px;
      position: relative;

      &:after {
        content: '';
        background: url('../../assets/images/common/separator.svg') center center no-repeat;
        background-size: contain;
        width: 16px;
        height: 16px;
        display: block;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
      }

      a {
        display: block;
        color: #FE6B01;
        font-size: 11px;
        line-height: 14px;
        line-height: 1;
        white-space: nowrap;
      }

      &:last-of-type {
        margin-right: 0;
        padding-right: 0;

        &:after {
          content: none;
        }
      }

      &.current {
        a {
          color: #707070;
          pointer-events: none;
        }
      }
    }
  }
}
</style>